import React from 'react';
import { connect } from 'react-redux';

import { Button, Form, SidebarContent } from 'components';

import { setSidebar } from 'redux/reducers/app';
import { getChildBirthday, getChildId, getChildName } from 'redux/selectors/orders';
import { getActiveOrderId } from 'redux/selectors/app';
import { setOption } from 'redux/reducers/orders';
import { addChild } from 'redux/reducers/user';

import styles from './styles.scss';
import { getChildren } from '../../redux/selectors/user';

@connect(
  (state, props) => ({
    orderId: getActiveOrderId(state),
    // books: state.getIn(['books'], List()),
    // book: props.name !== undefined ? props.book : getBookId(state),
    children: getChildren(state),
    id: props.id !== undefined ? props.id : getChildId(state),
    name: props.name !== undefined ? props.name : getChildName(state),
    birthday: props.birthday !== undefined ? props.birthday : getChildBirthday(state),
  }),
  {
    setOption,
    setSidebar,
    addChild,
  }
)
export default class Child extends React.PureComponent {
  constructor(props, context) {
    super(props, context);

    this.state = {
      selectedId: null,
      addNew:
        props.children.count() === 0
          ? {
              name: '',
              birthday: '',
            }
          : null,
    };
  }

  componentWillMount() {
    this.props.setSidebar('child');
  }

  onNameChange = e => {
    const input = e.currentTarget;
    const { setOption, orderId, onChange, name: previousName, birthday: previousBirthDay } = this.props;
    const { addNew } = this.state;

    if (onChange) {
      onChange('name', input.value);
    } else if (addNew) {
      this.setState({
        addNew: {
          ...addNew,
          name: input.value,
        },
      });
    } else {
      setOption(orderId, ['child', 'name'], input.value, {
        previousName,
        previousBirthDay,
      });
    }
  };

  onDateChange = date => {
    const { setOption, orderId, onChange, birthday: previousBirthDay, name: previousName } = this.props;
    const { addNew } = this.state;

    if (onChange) {
      onChange('birthday', date);
    } else if (addNew) {
      this.setState({
        addNew: {
          ...addNew,
          birthday: date,
        },
      });
    } else {
      setOption(orderId, ['child', 'birthday'], date, {
        previousName,
        previousBirthDay,
      });
    }
  };

  toPhotos = () => {
    const { addNew } = this.state;

    if (addNew) {
      const { name, birthday } = addNew;
      this.props.addChild(name, birthday);

      this.setState({
        selectedId: null,
        addNew: null,
      });
    }

    this.props.setSidebar('photos');
  };

  selectChild = e => {
    const { setOption, orderId, birthday: previousBirthDay, name: previousName, id: previousId, children } = this.props;
    const childId = e.currentTarget.dataset.id;

    const selectedChild = children.find(child => child.get('id') === childId);

    if (selectedChild) {
      setOption(orderId, 'child', selectedChild, {
        previousId,
        previousName,
        previousBirthDay,
      });

      this.setState({
        selectedId: childId,
        addNew: null,
      });
    }
  };

  toAddChild = () => {
    this.setState({
      addNew: {
        name: '',
        birthday: '',
      },
    });
  };

  toChild = () => {
    this.setState({
      selectedId: null,
      addNew: null,
    });

    this.props.setSidebar('child');
  };

  render() {
    let { id = '', name = '', birthday = '', asSidebar = true, children } = this.props;
    const { selectedId, addNew } = this.state;

    const Wrapper = asSidebar ? SidebarContent : 'div';

    if (addNew) {
      id = null;
      name = addNew.name;
      birthday = addNew.birthday;
    } else if (!selectedId) {
      const currentChild = children.find(child => {
        return child.get('id') === id;
      });
      const otherChildren = children.filter(child => {
        return child.get('id') !== id;
      });

      return (
        <Wrapper title={kroostApp.strings.kidSectionTtitle}>
          {currentChild ? (
            <div>
              {kroostApp.strings.childBookTargetInput}
              <Button onClick={this.selectChild} data-id={currentChild.get('id')} fullWidth secondary white leftAlign>
                {currentChild.get('name')}
              </Button>
            </div>
          ) : null}

          {otherChildren.count() > 0 ? (
            <div>
              {!!currentChild && (
                <div>
                  <br />
                  <br />
                </div>
              )}
              {!currentChild ? kroostApp.strings.childBookTargetOption1 : kroostApp.strings.childBookTargetOption2}
              {otherChildren.map(child => {
                return (
                  <Button
                    key={child.get('id')}
                    onClick={this.selectChild}
                    data-id={child.get('id')}
                    fullWidth
                    secondary
                    white
                    leftAlign>
                    {child.get('name')}
                  </Button>
                );
              })}
            </div>
          ) : null}

          <Button onClick={this.toAddChild} fullWidth secondary>
            {otherChildren
              ? kroostApp.strings.childBookStartButtonOption2
              : kroostApp.strings.childBookStartButtonOption1}
          </Button>
        </Wrapper>
      );
    }

    if (selectedId) {
      const selectedChild = children.find(child => child.get('id') === selectedId);
      if (selectedChild) {
        id = selectedChild.get('id');
        name = selectedChild.get('name');
        birthday = selectedChild.get('birthday');
      }
    }

    return (
      <Wrapper title={kroostApp.strings.kidSectionTtitle}>
        <p>{kroostApp.strings.childIntro}</p>
        <Form.Input
          name="name"
          type="text"
          label={kroostApp.strings.childFormInputNameLabel}
          placeholder={kroostApp.strings.childFormInputNamePlaceholder}
          value={name}
          maxLength="12"
          onChange={this.onNameChange}
        />

        {name.length === 12 ? <span>{kroostApp.strings.childFormInputLettersInformation}</span> : null}

        <Form.DatePicker
          name="birthday"
          className={styles.birthday}
          label={kroostApp.strings.childFormInputDateLabel}
          value={birthday}
          onChange={this.onDateChange}
        />

        <Form.Row className={styles.actions}>
          <Button cta className={styles.go} disabled={!name || !birthday} onClick={this.toPhotos}>
            {kroostApp.strings.getStartedButton}
          </Button>
        </Form.Row>

        {asSidebar ? (
          <Form.Row className={styles.actions}>
            <Button className={styles.back} onClick={this.toChild}>
              {kroostApp.strings.backButton}
            </Button>
          </Form.Row>
        ) : null}
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/child/index.js